/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateTestClientRequestBody
 */
export interface CreateTestClientRequestBody {
    /**
     * 
     * @type {string}
     * @memberof CreateTestClientRequestBody
     */
    description: string;
}

/**
 * Check if a given object implements the CreateTestClientRequestBody interface.
 */
export function instanceOfCreateTestClientRequestBody(value: object): value is CreateTestClientRequestBody {
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function CreateTestClientRequestBodyFromJSON(json: any): CreateTestClientRequestBody {
    return CreateTestClientRequestBodyFromJSONTyped(json, false);
}

export function CreateTestClientRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTestClientRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'],
    };
}

export function CreateTestClientRequestBodyToJSON(json: any): CreateTestClientRequestBody {
    return CreateTestClientRequestBodyToJSONTyped(json, false);
}

export function CreateTestClientRequestBodyToJSONTyped(value?: CreateTestClientRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
    };
}

